import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import * as resources from '../resources';

i18n
	.use(detector)
	.use(initReactI18next)
	.init({
		compatibilityJSON: 'v4',
		resources: {
			...Object.entries(resources).reduce(
				(acc, [key, value]) => ({
					...acc,
					[key]: {
						translation: value,
					},
				}),
				{}
			),
		},
		fallbackLng: 'es',
	});

export const setupDocumentLanguage = () => {
	document.documentElement.lang = i18n.language;
};

export default i18n;
